import { useEffect } from "react";
import { getSeo } from "../seo";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

// Keeps <head> in sync on client-side navigation; the build prerender writes the same values statically.
export const Seo = ({ lang, rest }) => {
  useEffect(() => {
    const s = getSeo(lang, rest);
    document.title = s.title;
    document.documentElement.lang = lang;
    setMeta("name", "description", s.description);
    setMeta("property", "og:title", s.title);
    setMeta("property", "og:description", s.description);
    setMeta("property", "og:locale", s.ogLocale);
    setMeta("name", "robots", s.found ? "index, follow, max-image-preview:large" : "noindex");
    document.head.querySelectorAll('link[rel="canonical"],link[rel="alternate"][hreflang],script[data-ld]').forEach((n) => n.remove());
    if (s.canonical) {
      const add = (attrs) => {
        const l = document.createElement("link");
        Object.entries(attrs).forEach(([k, v]) => l.setAttribute(k, v));
        document.head.appendChild(l);
      };
      add({ rel: "canonical", href: s.canonical });
      setMeta("property", "og:url", s.canonical);
      s.alternates.forEach((a) => add({ rel: "alternate", hreflang: a.hreflang, href: a.href }));
      add({ rel: "alternate", hreflang: "x-default", href: s.xDefault });
    }
  }, [lang, rest]);
  return null;
};
